import { useState } from 'react';
import logo from '../img/logo.svg';
import '../css/App.css';
import { Link, useLocation } from 'react-router-dom';
import { useDocumentTitle } from '../ts/useDocumentTitle';


async function Join(name: string, id: number) {
  await fetch(`http://localhost:5001/api/parties/${id}/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user: { name },partyId: {id} }),
  });
}
function JoinGame() {
  useDocumentTitle('Join Game');
  const [code, setCode] = useState('');
  const trimmed = code.trim();
  const isSixDigitInteger = /^\d{6}$/.test(trimmed);
  const { state } = useLocation();
const playerName = state?.playerName ?? '';
  const canProceed = isSixDigitInteger;

  return (
    <div className="App">
      <header className="App-header"></header>
      <main className="App-body">
        <div className="content-card">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="card-title">Join a Game</h1>
          <p className="pill">Enter the 6-digit game code shared by the host.</p>

          <div className="input-section" style={{ maxWidth: 360, width: '100%' }}>
            <input className="App-input"
              name="GameCodeInput"
              placeholder="Game code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={6}
            />
          </div>

          <div className="button-row">
            {canProceed ? (
              <Link to="/GameLobby" state={{ partyId: Number(code), playerName }} style={{ flex: 1 }}>
                <button className="Base-button-ready" style={{ width: '100%' }} onClick={() => Join(playerName, Number(code))}>Join game</button>
              </Link>
            ) : (
              <button disabled className="Base-button-not-ready" style={{ width: '100%' }}>Join game</button>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default JoinGame;